/* raw layout hash: _anonymous-web-layout-18yitw0:abdb170dcc390b4189f97f48986cce5da922f08f5d3525f921108aa2271997f1 */
import React from 'react';
import AnonymousShell from './AnonymousShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_anonymous-web-layout-18yitw0" — renders its page content through the router outlet.
export default function AnonymousWebLayout18yitw0() {
  return <AnonymousShell layoutName="_anonymous-web-layout-18yitw0" menu={LAYOUT_MENUS['_anonymous-web-layout-18yitw0']} />;
}
